"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var classnames_1 = __importDefault(require("classnames"));
var _colors_scss_1 = __importDefault(require("../../styles/_colors.scss"));
var IconSvg = function (_a) {
    var name = _a.name, _b = _a.fill, fill = _b === void 0 ? "#fff" : _b, _c = _a.size, size = _c === void 0 ? 24 : _c;
    switch (name) {
        case "close":
            return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: size, height: size, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("rect", { y: "-0.492741", width: "21.9959", height: "1.71409", rx: "0.857045", transform: "matrix(0.710284 0.703915 -0.710284 0.703915 1.37023 0.854107)", fill: fill, stroke: "#ffffff", "stroke-width": "0.7" }), (0, jsx_runtime_1.jsx)("rect", { x: "0.497199", y: "4.17233e-08", width: "21.9959", height: "1.71409", rx: "0.857045", transform: "matrix(-0.710284 0.703915 -0.710284 -0.703915 17.8504 1.65783)", fill: fill, stroke: "#ffffff", "stroke-width": "0.7" })] })));
        case "chevron":
            return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.8941 10.6261L19.6216 2.14726C20.1168 1.66621 20.1282 0.874834 19.6471 0.379676C19.1661 -0.115482 18.3747 -0.12692 17.8796 0.354131L10.0003 8.00891L2.12102 0.354131C1.62586 -0.12692 0.834488 -0.115482 0.353437 0.379676C-0.127613 0.874834 -0.116176 1.66621 0.378982 2.14726L9.10648 10.6261C9.35125 10.8763 9.67561 11.002 10.0003 11.002C10.325 11.002 10.6493 10.8763 10.8941 10.6261Z", fill: fill }) })));
        case "bullet-shadow":
            return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: size, height: size, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "11", cy: "9", r: "9", fill: "#FFAAB8" }), (0, jsx_runtime_1.jsx)("circle", { cx: "9", cy: "12", r: "8.25", stroke: "#2B59DB", "stroke-width": "1.5" })] })));
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
};
var Icon = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c, name = _a.name, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, style = _a.style, props = __rest(_a, ["className", "size", "color", "name", "onClick", "style"]);
    // support non-generic colors
    switch (color) {
        case "primary":
            color = _colors_scss_1["default"].primary;
            break;
        default:
    }
    return ((0, jsx_runtime_1.jsx)("i", __assign({ style: style, onClick: onClick, className: (0, classnames_1["default"])(className, styles_scss_1["default"].icon) }, { children: (0, jsx_runtime_1.jsx)(IconSvg, { name: name, fill: color, size: size }) })));
};
exports["default"] = Icon;
